const StatisticalSearch = r => require.ensure([], () => r(require('@/page/StatisticalSearch/StatisticalSearch')), 'StatisticalSearch');
const queryOrganMge = r => require.ensure([], () => r(require('@/page/organMge/queryOrganMge/queryOrganMge')), 'queryOrganMge');
const businessDocSearch = r => require.ensure([], () => r(require('@/page/businessDocSearch/businessDocSearch')), 'businessDocSearch');
const queryPropertyArea = r => require.ensure([], () => r(require('@/page/propertyAreaMge/queryPropertyArea/queryPropertyArea')), 'queryPropertyArea');
const StatisticalSearchRouter ={
  path:'',
  component:StatisticalSearch,
  meta:{
    icon: 'organMge',
    right: [],
    isShowMenu: false,
    keepAlive:true
  },
  name: '统计查询',
  redirect: '/queryOrganMgeSearchs',
  children:[
    {
      path: '/queryOrganMgeSearchs',
      component: queryOrganMge,
      name: '统计查询', 
      meta: {
        name: '机构查询',
        right: ['机构查询'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/businessDocSearchSearchs',
      component: businessDocSearch,
      name: '统计查询',
      meta: {
        name: '业务单查询',
        right: ['业务单查询'],
        isShowMenu: false,
        keepAlive:true
      },
    },
    {
      path: '/queryPropertyAreaSearchs',
      component: queryPropertyArea,
      name: '统计查询',
      meta: {
        name: '物业区域查询',
        right: ['物业区域查询'],
        isShowMenu: false,
        keepAlive:true
      },
    },
  ]
};
export default StatisticalSearchRouter ;